export default {
  paged: {
    select:
      'id,created,kind,billingOperationId,amount,currency,sequence,aiConsumptionId,referenceKey',
    orderBy: 'created desc',
    searchSelect: ['referenceKey'],
  },
};
